import { Axios } from '@/request/axios';
import { debugWechatJsapi, getWechatDebugError } from '@/utils/wechatDebug';

interface IWxLoginResponse {
  openid: string;
  unionid?: string;
}

// 使用微信 OAuth 回调 code 换取当前服务号下的 OpenID
const wxLogin = async (code: string): Promise<string> => {
  debugWechatJsapi('步骤 5/11：开始请求 POST /api/wx/login，已携带 OAuth code（code 已脱敏）');

  try {
    const { data } = await Axios.post<IWxLoginResponse>('/wx/login', { code });

    if (!data?.openid) {
      throw new Error('接口响应成功，但 data.openid 缺失');
    }

    debugWechatJsapi('步骤 6/11：/api/wx/login 成功，已获取 OpenID（值已脱敏）');
    return data.openid;
  } catch (error) {
    const details = getWechatDebugError(error);
    debugWechatJsapi(`步骤 6/11：/api/wx/login 失败，${details}`);
    throw new Error(`微信登录失败：${details}`);
  }
};

export { wxLogin };
